// extracted by mini-css-extract-plugin
export default {"container":"formLayout_container__jSAXy","pasted__text":"formLayout_pasted__text__xokw8","form__loading":"formLayout_form__loading__Phm9w"};